import React from 'react';
import _StudentService from '../../modules/StudentService';
import MyInput from 'components/controls/MyInput';
import { Modal, Steps, Icon } from 'antd';
import { useEffect, useCallback, useRef  } from 'react';
import { useState } from 'react';
import { Spin } from 'antd';
import moment from 'moment';
import { ROOT_PATH } from '../../constants/constants'
// Stage 3.6 (Enterprise Shared Component Stabilization): replaces the hand-written
// .ent-status-badge span below with the shared StatusBadge component — same CSS classes, same
// rendered output, now going through the one shared implementation instead of a local copy.
import StatusBadge from 'components/enterprise/StatusBadge';
// Stage 3.7 (Enterprise Candidate Dashboard Modernization): Card wraps every dashboard section;
// Alert becomes its first real consumer anywhere in the app, for the existing "Note:" blocks —
// see frontendDesign/Stage_3_7/Implementation/ERPM_S3_7_Implementation_Plan.md. Neither shared
// component is itself modified.
import Card from 'components/enterprise/Card';
import Alert from 'components/enterprise/Alert';
// Phase C.7.3 (§11): replaces this file's antd `Button` (was imported alongside Modal/Steps/Icon
// above) with the new reusable, token-driven `.ent-btn*` primitive — every onClick/disabled
// condition below is preserved exactly, only the button's own presentation component changed.
import Button from 'components/enterprise/Button';
// Phase E (centralized language resource migration): Text/resolveText render this file's strings
// from modules/i18n/pages/homeSummary.js (dot-path "homeSummary.*") instead of hardcoded
// English+Marathi literals. useLanguage() is called once here (functional component) so its
// locale/displayMode can be reused by resolveText() calls made from the nested
// QuestionAnswerSheetViewer component below via closure.
import Text, { resolveText } from 'components/Text/Text';
import { useLanguage } from 'modules/LanguageContext';

 //const pdfjsLib = require('pdfjs-dist');

const HomePageSummary_new = (props) => {

    const { locale, displayMode } = useLanguage();

    const [isLoading, setIsLoading] = useState(true);
    const [showChallan, setShowChallan] = useState(false);
    const [showSubmit, setShowSubmit] = useState(false);
    const [showExamCard, setShowExamCard] = useState(false);
    const [Data, setData] = useState(false);

    const [PersonalData, setPersonalData] = useState(false);
    const [QualificationData, setQualificationData] = useState(true);
    const [ReservationData, setReservationData] = useState(true);
    const [PhotoSignature, setPhotoSignature] = useState(true);
    const [ExamCard, setExamCard] = useState(true);
    const [IsAllowExamCardDownload, setIsAllowExamCardDownload] = useState(true);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [IsExamPaymentOnline, setIsExamPaymentOnline] = useState(false);
    const [hasDataError, setHasDataError] = useState(true);

    const [questionAnswerSheetlink, setQuestionAnswerSheetlink] = useState("");

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [aakshepMessage, setAakshepMessage] = useState("");

    //Below code for steps integrations
  const { Step } = Steps;

  const [current, setCurrent] = useState(0);
   
  const handleStepChange = (nextStep) => {
      setCurrent(nextStep);
  };

  // Function to go to the next step
  const next = () => {
    setCurrent(current + 1);
  };

  // Function to go to the previous step
  const prev = () => {
    setCurrent(current - 1);
  };


    const QuestionAnswerSheetViewer = ({ questionAnswerSheetLink }) => (
        <iframe
            src={`${questionAnswerSheetlink}#toolbar=0&navpanes=0&scrollbar=0`}
            width="100%"
            height="100%"
            title={resolveText('homeSummary.answerKeyViewerTitle', locale, displayMode)}
            style={{ border: 'none', margin: 0, padding: 0 }}
        ></iframe>
    );

    const QuestionAnswerSheetModal = ({ questionAnswerSheetLink }) => {

        const showModal = () => {
            setIsModalVisible(true);
        };

        const handleCancel = () => {
            setIsModalVisible(false);
        };

        return (
            <div className="d-flex w-100 justify-content-center">
                <div>
                    <div>
                        <Button
                            variant="primary"
                            onClick={showModal}
                            disabled={questionAnswerSheetlink === "" ? true : false}
                        >
                            <Text k="homeSummary.answerKeyButtonLabel" />
                        </Button>
                    </div>
                </div>
                <Modal
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={[
                        <Button
                        key="cancel"
                        variant="secondary"
                        onClick={handleCancel}
                        >
                            <Text k="homeSummary.closeButtonLabel" />
                        </Button>
                    ]}
                    width="80%"
                    bodyStyle={{ height: "80vh", padding: 0, overflow: "hidden" }}
                    style={{ top: "5%" }}
                    closable={false}

                >
                    <QuestionAnswerSheetViewer questionAnswerSheetLink={questionAnswerSheetLink} />

                </Modal>
            </div>
        );
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 'p') {
                event.preventDefault();
                //alert('Printing is disabled on this page.');
            }
        };

        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {

        //console.log("componentDidMount");
        getStudentProcessStatus();
        getStudentAnswerPaperPDFName();
        getStudentAakshepDataForStudent();
        //console.log("Prop: ", props.test);

    }, []);

    useEffect(() => {
      if (!IsExamPaymentOnline && isSubmitted) {
        setCurrent(3);
      } else if (IsExamPaymentOnline && isSubmitted) {
        setCurrent(2);
      } else {
        setCurrent(0);
      }

      // Candidate Journey Correction phase (28 Aug 2026) — real defect fix: this override never
      // checked `isSubmitted`, so a candidate who had just registered (never submitted anything —
      // Is_Submitted still null) was forced straight to the Result step the instant the portal-wide
      // "Declare Result" admin toggle (backend PortalConfiguration.isViewResult) was on anywhere in
      // the system, regardless of their own actual progress — reproducible for every new
      // registration once that toggle is on. Also fixed server-side (StudentService.GetStudentData)
      // so isViewResult itself is never true for an unsubmitted candidate; `isSubmitted` is kept here
      // too, defense-in-depth, consistent with the other two branches above.
      if (IsExamPaymentOnline && isSubmitted && props.data.isViewResult) {
        setCurrent(3);
      }

    }, [IsExamPaymentOnline, isSubmitted]);

    const getStudentAnswerPaperPDFName = useCallback(async () => {
      try {
          let response = await _StudentService.getStudentAnswerPaperPDFName();

          let fileName = ""

          if (response && response.data !== "") {
              fileName = ROOT_PATH + "/Templates/QuestionPaper/" + response.data;
          }
          else {
              fileName = "";
          }
          setQuestionAnswerSheetlink(fileName)
      } catch (error) {

      }
  }, [])

    const getStudentProcessStatus = useCallback(async () => {
        try {
            let response = await _StudentService.getStudentProcessStatus();
            //console.log("StudentProcessStatus Data: ", response);

            if (response.data && !response.data.IsSuccess) {
                setHasDataError(true);
                setIsLoading(false);
            }
            else {
                setHasDataError(false);
                let checker = arr => arr.every(Boolean);

                setIsAllowExamCardDownload(response.data.Obj.IsAllowExamCardDownload);

                // let challanArray = [response.data.Obj.Is_Personal_Data, response.data.Obj.Is_Qualification_Data, response.data.Obj.Is_Reservation_Data, response.data.Obj.Is_Images_Data];
                let challanArray = [response.data.Obj.Is_Personal_Data, response.data.Obj.Is_Qualification_Data, response.data.Obj.Is_Images_Data];
                setShowChallan(checker(challanArray));

                // let submitArray = [response.data.Obj.Is_Personal_Data, response.data.Obj.Is_Qualification_Data, response.data.Obj.Is_Reservation_Data, response.data.Obj.Is_Images_Data];
                let submitArray = [response.data.Obj.Is_Personal_Data, response.data.Obj.Is_Qualification_Data, response.data.Obj.Is_Images_Data];
                let submitFlag = checker(submitArray);
                if (submitFlag && !response.data.Obj.Is_Submitted) {
                    setShowSubmit(false);
                }
                else {
                    setShowSubmit(true); // for already submitted                
                }

                setIsSubmitted(!!response.data.Obj.Is_Submitted);

                setShowExamCard(response.data.Obj.Is_Submitted);

                setIsExamPaymentOnline(response.data.Obj.IsExamPaymentOnline);

                if (response.data.Obj.Is_Submitted) {
                    //console.log("Here");
                    setPersonalData(true);
                    setQualificationData(true);
                    // setReservationData(true);
                    setPhotoSignature(true);
                    setShowChallan(false);
                }
                else {
                    //console.log("else ", response.data.Obj.Is_Personal_Data);
                    if (response.data.Obj.Is_Personal_Data)
                        setQualificationData(false);
                    if (response.data.Obj.Is_Qualification_Data)
                        //     setReservationData(false);
                        // if (response.data.Obj.Is_Reservation_Data)
                        setPhotoSignature(false);
                }

                //Check if exam card download enabled by admin
                setExamCard(false);
                //console.log("PersonalData: ", PersonalData, "QualificationData: ", QualificationData, "ReservationData: ", ReservationData, "Photo: ", PhotoSignature);
                setData(response.data.Obj);
                
                setIsLoading(false);

            }
        } catch (e) { setIsLoading(false); }
    }, []) // if [] changes, useEffect will run again


    const getStudentAakshepDataForStudent = useCallback(async () => {
      try {
          let response = await _StudentService.GetStudentAakshepDataForStudent();
          if (response && response.data && response.data.Obj && response.data.Obj.length > 0) {
              const message = response.data.Obj[0].AakshepMessage;
              setAakshepMessage(message);
          }
      } catch (error) {
          console.error("Error fetching Aakshep message:", error);
      }
  });

    if (props.data) {
      if (isLoading)
            return <Spin size="large" />
          return (
          <div className="ent-container">
            {/* Phase C.7.3 (§13/§14 — Candidate Identity Card): consolidates what used to be TWO
                separate blocks — NavigationTab_new_one.jsx's own identity strip (previously rendered
                separately by CandidateRegistration.jsx for the dashboard only; see that file's own
                comment) and this Card's former narrower "Application Summary" (Name/Applied Post/
                Status only) — into ONE compact card, each field appearing exactly once. Every field
                below comes from props.data, the exact same getStudentPersonalInfo() response
                NavigationTab_new_one used independently (CandidateRegistration.jsx fetches it once
                and passes it down as `data` — confirmed identical shape via a live field-by-field
                comparison) — no new API call. NavigationTab_new_one.jsx itself is untouched and still
                renders identically on all 6 wizard sub-pages, which each call it independently. */}
            <Card header={<h2 className="displayInGrid"><Text k="homeSummary.applicationSummaryHeader" /></h2>}>
              <div className="ent-identity-grid">
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="homeSummary.candidateNameLabel" /></div>
                  <div className="ent-identity-value ent-identity-value-primary">
                    {[props.data.First_Name, props.data.Middle_Name, props.data.Last_Name].filter(Boolean).join(' ')}
                  </div>
                </div>
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="navigationTab.formNumberLabel" /></div>
                  <div className="ent-identity-value">{props.data.Form_Number || 'N/A'}</div>
                </div>
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="homeSummary.appliedPostLabel" /></div>
                  <div className="ent-identity-value">{props.data.Applied_Post || 'N/A'}</div>
                </div>
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="navigationTab.dobLabel" /></div>
                  <div className="ent-identity-value">
                    {props.data.Birth_Date && moment(props.data.Birth_Date).isValid()
                      ? moment(props.data.Birth_Date).format('DD-MMMM-YYYY')
                      : 'N/A'}
                  </div>
                </div>
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="navigationTab.mobileNumberLabel" /></div>
                  <div className="ent-identity-value">{props.data.Mobile_Number || 'N/A'}</div>
                </div>
                <div className="ent-identity-cell">
                  <div className="ent-field-label"><Text k="homeSummary.currentStatusLabel" /></div>
                  <StatusBadge
                    status={isSubmitted ? 'Application Submitted' : 'Application In Progress'}
                    tone={isSubmitted ? 'success' : 'info'}
                  />
                </div>
              </div>
            </Card>

            {questionAnswerSheetlink !== "" && (
              <div className="mt-4">
                <Card>
                  <div className="d-flex w-100 justify-content-center">
                    <QuestionAnswerSheetModal />
                  </div>
                </Card>
              </div>
            )}

            {/* Phase C.9 (Answer Key & Lightweight Online Objection Workflow) — a distinct, new,
                versioned (First/Final) Answer Key feature with an objection workflow attached, separate
                from the Question Paper card above. Always shown once submitted; the Answer Key screen
                itself tells the candidate if nothing has been published for their batch yet. */}
            {isSubmitted && (
              <div className="mt-4">
                <Card>
                  <div className="d-flex w-100 justify-content-center">
                    <Button variant="primary" onClick={() => props.onTabOrderChange(11)}>
                      Answer Key &amp; Objections
                    </Button>
                  </div>
                </Card>
              </div>
            )}

                {/* Candidate Journey Consolidation phase (28 Aug 2026) — real defect fix: this used to
                    be a standalone, always-visible dashboard entry point shown to EVERY submitted
                    candidate regardless of whether they were ever interview-shortlisted — a Failed or
                    Exam-Absent candidate could click through to an Interview Schedule screen that could
                    never apply to them. Removed per explicit request: Interview Schedule/Call Letter
                    access is now reachable ONLY from the Result screen's own "View" button (ResultCard_new
                    already renders "View Interview Schedule" / "View / Download Interview Call Letter"
                    there, gated on the real IsInterviewShortlisted flag) — a single, correctly-gated entry
                    point instead of two, one of which was never gated at all. */}

                {aakshepMessage !== "" && (
                    <div className="mt-3">
                      {/* Phase C.7.4D-R2 (§3): mr-1 removed — .ent-alert-title's own `gap` (themes.scss) now
                  handles icon-to-heading spacing instead of a Bootstrap margin utility. */}
              <Alert type="info" title={<><Icon type="info-circle" /><Text k="homeSummary.noteLabel" /></>}>
                        <div dangerouslySetInnerHTML={{ __html: aakshepMessage }}></div>
                      </Alert>
                    </div>
                )}

            {/* Phase R6.7 (§2): this instructional "fill fields correctly / can't be updated after
                submission" Note is only actionable pre-submission — once Is_Submitted is true (the
                same existing status flag driving every "View" vs "View/Modify" button above), it has
                nothing left to instruct, and was still showing on the Receipt & Admit Card step.
                Gated on the existing `isSubmitted` state rather than the current step index, since
                every step on this page is already read-only once submitted, not just Receipt & Admit
                Card. The Note itself is untouched/unremoved for the entire pre-submission journey. */}
            {!hasDataError && !isSubmitted && (
              <div className="mt-3">
                {/* Phase C.7.4D-R2 (§3): mr-1 removed — .ent-alert-title's own `gap` (themes.scss) now
                  handles icon-to-heading spacing instead of a Bootstrap margin utility. */}
              <Alert type="info" title={<><Icon type="info-circle" /><Text k="homeSummary.noteLabel" /></>}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: localStorage["Exam_note"],
                    }}
                  ></div>
                </Alert>
              </div>
            )}
            {!hasDataError && (
              <div className="chsteps mt-4">
                <Card header={<h2 className="displayInGrid"><Text k="homeSummary.applicationProgressHeader" /></h2>}>
                    <div className="chsteps-nav">
                      <Steps
                        current={current}
                        onChange={handleStepChange}
                        size="medium"
                        type="navigation"
                      >
                        {/* Phase C.7.2 (§21 stepper foundation): descriptive titles replacing the
                            previous generic "Step 1"/"Step N" labels — presentation-only, the
                            `current` index/onChange navigation and every disabled/lock condition
                            below (unchanged) remain the sole source of truth for what's actually
                            reachable. See homeSummary.js's stepDetailsTitle comment for why these
                            5 labels don't reuse the wizard's own WizardSteps.jsx title set: this
                            Steps instance groups multiple wizard sub-pages per header position
                            (e.g. Personal+Qualification+Photo+Preview all under one "Application
                            Details" step), so it is a distinct, coarser-grained view onto the same
                            journey rather than a 1:1 duplicate of WizardSteps — see the
                            C.7.2 report's stepper-architecture finding for the full comparison. */}
                        <Step
                            title={<Text k="homeSummary.stepDetailsTitle" />}
                        />
                        {!IsExamPaymentOnline &&
                          <Step
                            title={<Text k="homeSummary.stepChallanTitle" />}
                          />
                        }
                        <Step
                            title={<Text k="homeSummary.stepPaymentTitle" />}
                        />
                        <Step
                           title={<Text k="homeSummary.stepReceiptTitle" />}
                        />
                        <Step
                           title={<Text k="homeSummary.stepResultTitle" />}
                        />
                        
                        
                      </Steps>
                    </div>

                    <div className="chsteps-content-wrap  mt-4 ">
                      <div className="steps-content">

                        {/* Step 1: Personal Information */}
                        {current === 0 && (
                          <div className="chsteps-content-inner p-3">
                            <h4 className="ch-heading4"><Text k="homeSummary.stepDetailsTitle" /></h4>
                            <div className="ent-dashboard-action-row">
                              <div>
                                <label>
                                  <Text k="homeSummary.personalInformationLabel" />
                                </label>
                              </div>
                              <Button
                                variant={PersonalData ? "secondary" : "primary"}
                                disabled={PersonalData}
                                onClick={() => props.onTabOrderChange(0)}
                              >
                                {isSubmitted ? "View" : "View / Modify"}
                              </Button>
                            </div>
                            <div className="ent-dashboard-action-row">
                              <div>
                                <label>
                                  <Text k="homeSummary.qualificationDetailsLabel" />
                                </label>
                              </div>

                              <Button
                                variant={QualificationData ? "secondary" : "primary"}
                                disabled={QualificationData}
                                onClick={() => props.onTabOrderChange(1)}
                              >
                                {isSubmitted ? "View" : "View / Modify"}
                              </Button>
                            </div>

                            {/* Reservation Details section  */}
                            {/* <div className="ent-dashboard-action-row">
                              <div>
                                <label>
                                Reservation Details <br />
                                (आरक्षण माहिती)
                                </label>
                              </div>

                              <Button
                                className={
                                  isSubmitted
                                    ? "button-global button-border autoHeight disabled"
                                    : "button-global button-primary autoHeight"
                                }
                                onClick={() => props.onTabOrderChange(2)}
                              >
                               {isSubmitted ? "View" : "View / Modify"}
                              </Button>
                            </div> */}

                            <div className="ent-dashboard-action-row">
                              <div>
                                <label>
                                  <Text k="homeSummary.photoSignatureUploadLabel" />
                                </label>
                              </div>

                              <Button
                                variant={PhotoSignature ? "secondary" : "primary"}
                                disabled={PhotoSignature}
                                onClick={() => props.onTabOrderChange(3)}
                              >
                                {isSubmitted ? "View" : "View / Modify"}
                              </Button>
                            </div>
                            <div className="ent-dashboard-action-row">
                              <div>
                                <label>
                                  <Text k="homeSummary.previewCandidateDetailsLabel" />
                                </label>
                              </div>

                              <Button
                                variant={showSubmit ? "secondary" : "primary"}
                                disabled={showSubmit}
                                onClick={() => props.onTabOrderChange(10)}
                              >
                                {isSubmitted ? "View" : "Preview Application"}
                              </Button>
                            </div>
                          </div>
                        )}

                        {/* Step 2: Payment Done */}
                        {current === 1 && !IsExamPaymentOnline && (
                          <div className="chsteps-content-inner p-3">
                                <h4 className="ch-heading4"><Text k="homeSummary.stepChallanTitle" /></h4>

                                <div className="ent-dashboard-action-row">
                                  <div>
                                    <label>
                                      <Text k="homeSummary.viewPrintChallanLabel" />
                                    </label>
                                  </div>
                                  <Button
                                    variant={!showChallan ? "secondary" : "primary"}
                                    disabled={!showChallan}
                                    onClick={() => props.onTabOrderChange(4)}
                                  >
                                    View
                                  </Button>
                                </div>
                             
                           
                          </div>
                        )}

                        {/* Step 3: Make payment */}
                        {current === (IsExamPaymentOnline ? 1 : 2) && (
                          <div className="chsteps-content-inner p-3">
                                <h4 className="ch-heading4"><Text k="homeSummary.stepPaymentTitle" /></h4>

                                <div className="ent-dashboard-action-row">
                                  <div>
                                    <label>
                                      {IsExamPaymentOnline ? (
                                        <Text k="homeSummary.makePaymentLabel" />
                                      ) : (
                                        <Text k="homeSummary.submitFormLabel" />
                                      )}
                                    </label>
                                  </div>
                                  <Button
                                    variant={showSubmit ? "secondary" : "primary"}
                                    disabled={showSubmit}
                                    onClick={() => props.onTabOrderChange(5)}
                                  >
                                    {isSubmitted
                                      ? "Submited"
                                      : IsExamPaymentOnline
                                      ? "Make Payment"
                                      : "Submit Form"}
                                  </Button>
                                </div>
                          </div>
                        )}

                        {/* Step 4: Confirmation */}
                        {current === (IsExamPaymentOnline ? 2 : 3) && (
                          <div className="chsteps-content-inner p-3">
                          
                                <h4 className="ch-heading4"><Text k="homeSummary.stepReceiptTitle" /></h4>

                                <div className="ent-dashboard-action-row">
                                  <div>
                                    <label>
                                      <Text k="homeSummary.viewPrintReceiptLabel" />
                                    </label>
                                  </div>

                                  <Button
                                    variant={!showExamCard ? "secondary" : "primary"}
                                    disabled={!showExamCard}
                                    onClick={() => props.onTabOrderChange(6)}
                                  >
                                    View
                                  </Button>
                                </div>
                                <div className="ent-dashboard-action-row">
                                  <div>
                                    <label>
                                      <Text k="homeSummary.examCardLabel" />
                                    </label>
                                  </div>

                                  <Button
                                    variant={!IsAllowExamCardDownload ? "secondary" : "primary"}
                                    disabled={!IsAllowExamCardDownload}
                                    onClick={() => props.onTabOrderChange(7)}
                                  >
                                    View
                                  </Button>
                                </div>
                             
                          </div>
                        )}

                        {/* Step 5: Confirmation */}
                        {current === (IsExamPaymentOnline ? 3 : 4) && (
                          <div className="chsteps-content-inner p-3">
                                <h4 className="ch-heading4"><Text k="homeSummary.stepResultTitle" /></h4>

                                <div className="ent-dashboard-action-row">
                                  <div>
                                    <label>
                                      <Text k="homeSummary.resultLabel" />
                                    </label>
                                  </div>

                                  <Button
                                    variant={!props.data.isViewResult ? "secondary" : "primary"}
                                    disabled={!props.data.isViewResult}
                                    onClick={() => props.onTabOrderChange(8)}
                                  >
                                    View
                                  </Button>
                                </div>
                          </div>
                        )}
                       
                      </div>

                      {/* Step Controls — Candidate Journey Consolidation phase (28 Aug 2026): real defect
                          fix. "Next" was previously only ever disabled (never unrendered) on the last
                          step (Result), so it still visibly appeared — greyed out but present — on a
                          screen that is the end of the journey, with nowhere further to go. It's now
                          only rendered on steps that actually have a next step. */}
                      <div className="mt-4 d-flex justify-content-between">
                        <Button
                          variant="secondary"
                          onClick={prev}
                          disabled={current === 0}
                        >
                          Previous
                        </Button>

                        {!((IsExamPaymentOnline && current === 3) ||
                           (!IsExamPaymentOnline && current === 4)) && (
                          <Button
                            variant="primary"
                            onClick={next}
                          >
                            Next
                          </Button>
                        )}
                      </div>
                    </div>
                </Card>
              </div>
            )}
          </div>
        );
    }
    else {
        return <Spin size="large" />
    }
};

export default HomePageSummary_new;